import { createSelector } from 'reselect';
import { get } from 'lodash';

import { getIndexViewPixel } from '@sparefoot/react-core/utils/tracking';
import { getNearbyFacilities } from './getNearbyFacilities';

export default createSelector(
	(state) => state.pages.home,
	(state) => state.app.baseUrl,
	getNearbyFacilities,
	(home, baseUrl, nearbyFacilities) => ({
		meta: {
			...get(home, 'meta', {}),
			canonical: baseUrl + home?.meta?.canonical,
		},
		featuredCities: get(home, 'featuredCities', []),
		trackingPixel: getIndexViewPixel(),
		baseUrl: baseUrl,
		nearbyFacilities: nearbyFacilities,
	}),
);
